<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Báo cáo yêu cầu vé máy bay
      </h5>
    </template>

    <template #body>
      <el-form ref="form" label-position="left" label-width="150px">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Ngày tạo yêu cầu">
              <el-date-picker
                v-model="startTimeRange"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                placeholder="dd/MM/yyyy"
                :prefix-icon="' '"
                type="daterange"
                range-separator="-"
                format="dd/MM/yyyy"
                :picker-options="dateQuickFilterOption"
                @change="startTimeRangeChanged"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button class="btnSolid__blue" size="medium" @click="submit">
          <i class="fas fa-file-export"></i>
          &nbsp;Xuất báo cáo
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import CustomDialog from "../../common/custom-dialog";
import utils from "../../../services/utils";
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";

export default {
  name: "hc-maybay-report-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "id", "deptId"],
  components: {
    CustomDialog
  },
  data() {
    return {
      form: {
        fromStartTime: null,
        toStartTime: null
      },
      startTimeRange: null,
      dateQuickFilterOption: null
    };
  },

  created() {
    this.initDateQuickFilterOption();
    this.initStartTimeRange();
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  methods: {
    startTimeRangeChanged() {
      utils.timeRangeChanged(this.startTimeRange, (from_, to_) => {
        this.form.fromStartTime = from_;
        this.form.toStartTime = to_;
      });

      this.initStartTimeRange();
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    initStartTimeRange() {
      if (!this.startTimeRange) {
        utils.timeRangeChanged(
          (this.startTimeRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          )),
          (from_, to_) => {
            this.form.fromStartTime = from_;
            this.form.toStartTime = to_;
          }
        );
      }
    },

    submit() {
      let query = utils.merge(this.form, {
        userDeptRoleId: this.userDeptRoleId,
        deptId: this.deptId
      });
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.REPORT.MAY_BAY.REPORT_TH_URL;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
        "_blank "
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-report-dialog.vue